export type TEnvironments = "local" | "dev" | "stag" | "prod";
export type TServices = "EMAIL_SERVICE" | "GROUP_SERVICE" | "HOSTEL_SERVICE" | "MATCHING_PROFILE_SERVICE" | "NOTIFICATION_SERVICE" | "PLAN_SERVICE" | "POST_SERVICE" | "PROFILE_SERVICE" | "TRIP_SERVICE" | "USER_SERVICE" | "HANGOUT_SERVICE" | "CHAT_SERVICE";

export const API_ENDPOINTS: Record<TEnvironments, Record<TServices, string>> = {
  "local": {
    EMAIL_SERVICE: "http://localhost:6003/dev",
    GROUP_SERVICE: "http://localhost:6004/dev",
    HOSTEL_SERVICE: "http://localhost:6005/dev",
    MATCHING_PROFILE_SERVICE: "http://localhost:6012/dev",
    NOTIFICATION_SERVICE: "http://localhost:6006/dev",
    PLAN_SERVICE: "http://localhost:6007/dev",
    POST_SERVICE: "http://localhost:6008/dev",
    PROFILE_SERVICE: "http://localhost:6009/dev",
    TRIP_SERVICE: "http://localhost:6010/dev",
    USER_SERVICE: "http://localhost:3000/dev",
    HANGOUT_SERVICE: "http://localhost:6011/dev",
    CHAT_SERVICE: "http://localhost:4000",
  },
  "dev": {
    // EMAIL_SERVICE: "http://localhost:6003/dev",
    // GROUP_SERVICE: "http://localhost:6004/dev",
    // HOSTEL_SERVICE: "http://localhost:6005/dev",
    // MATCHING_PROFILE_SERVICE: "http://localhost:6012/dev",
    // NOTIFICATION_SERVICE: "http://localhost:6006/dev",
    // PLAN_SERVICE: "http://localhost:6007/dev",
    // POST_SERVICE: "http://localhost:6008/dev",
    // PROFILE_SERVICE: "http://localhost:6009/dev",
    // TRIP_SERVICE: "http://localhost:6010/dev",
    // USER_SERVICE: "http://localhost:3000/dev",
    // HANGOUT_SERVICE: "http://localhost:6011/dev",
    // CHAT_SERVICE: "localhost:4000",
    "EMAIL_SERVICE": "https://viv66bads6.execute-api.us-east-1.amazonaws.com/dev",
    "GROUP_SERVICE": "https://10ya2086l4.execute-api.us-east-1.amazonaws.com/dev",
    "HOSTEL_SERVICE": "https://2va1u88r56.execute-api.us-east-1.amazonaws.com/dev",
    "MATCHING_PROFILE_SERVICE": "https://u17t9z0ege.execute-api.us-east-1.amazonaws.com/dev",
    "NOTIFICATION_SERVICE": "https://znt1nki6wc.execute-api.us-east-1.amazonaws.com/dev",
    "PLAN_SERVICE": "https://qagcj26wkc.execute-api.us-east-1.amazonaws.com/dev",
    "POST_SERVICE": "https://y5trw6iqe3.execute-api.us-east-1.amazonaws.com/dev",
    "PROFILE_SERVICE": "https://8y9d6p42sd.execute-api.us-east-1.amazonaws.com/dev",
    "TRIP_SERVICE": "https://9egl4h533e.execute-api.us-east-1.amazonaws.com/dev",
    "USER_SERVICE": "https://xhyn07lg47.execute-api.us-east-1.amazonaws.com/dev",
    "HANGOUT_SERVICE": "https://8pm888tfh0.execute-api.us-east-1.amazonaws.com/dev",
    "CHAT_SERVICE": "chat-dev.goingsolo.app"//"http://3.89.12.78:4000"
  },
  "stag": {
    EMAIL_SERVICE: "https://u38eax86ya.execute-api.us-east-1.amazonaws.com/stag",
    GROUP_SERVICE: "https://ov6xz6vkuf.execute-api.us-east-1.amazonaws.com/stag",
    HOSTEL_SERVICE: "https://hp9zzz7tf8.execute-api.us-east-1.amazonaws.com/stag",
    MATCHING_PROFILE_SERVICE: "https://s557aq2pxc.execute-api.us-east-1.amazonaws.com/stag",
    NOTIFICATION_SERVICE: "https://l9uhbepqt5.execute-api.us-east-1.amazonaws.com/stag",
    PLAN_SERVICE: "https://ni0kw10mbi.execute-api.us-east-1.amazonaws.com/stag",
    POST_SERVICE: "https://xid6nwb1j5.execute-api.us-east-1.amazonaws.com/stag",
    PROFILE_SERVICE: "https://8mjudqfj3h.execute-api.us-east-1.amazonaws.com/stag",
    TRIP_SERVICE: "https://tkqnbyv22f.execute-api.us-east-1.amazonaws.com/stag",
    USER_SERVICE: "https://2batsrsntl.execute-api.us-east-1.amazonaws.com/stag",
    HANGOUT_SERVICE: "https://7xfrzxkd2c.execute-api.us-east-1.amazonaws.com/stag",
    CHAT_SERVICE: "3.90.82.85:4001",
  },
  "prod": {
    EMAIL_SERVICE: "https://ld7hpdslq2.execute-api.us-east-1.amazonaws.com/prod",
    GROUP_SERVICE: "https://o5kwegd4d1.execute-api.us-east-1.amazonaws.com/prod",
    HOSTEL_SERVICE: "https://vwt190bfa2.execute-api.us-east-1.amazonaws.com/prod",
    MATCHING_PROFILE_SERVICE: "https://vvwvzovtkj.execute-api.us-east-1.amazonaws.com/prod",
    NOTIFICATION_SERVICE: "https://kx5ng6oys0.execute-api.us-east-1.amazonaws.com/prod",
    PLAN_SERVICE: "https://zfjipt022d.execute-api.us-east-1.amazonaws.com/prod",
    POST_SERVICE: "https://5zsikf7ju2.execute-api.us-east-1.amazonaws.com/prod",
    PROFILE_SERVICE: "https://3r7jifxchb.execute-api.us-east-1.amazonaws.com/prod",
    TRIP_SERVICE: "https://0j4lf6n7f7.execute-api.us-east-1.amazonaws.com/prod",
    USER_SERVICE: "https://iqphi06h7h.execute-api.us-east-1.amazonaws.com/prod",
    HANGOUT_SERVICE: "https://e41tovoe8d.execute-api.us-east-1.amazonaws.com/prod",
    CHAT_SERVICE: "https://chat.goingsolo.app"//"52.2.176.136:4000",
  },
};
